import { render, staticRenderFns } from "./hdqd.vue?vue&type=template&id=0c644729&scoped=true&"
import script from "./hdqd.vue?vue&type=script&lang=js&"
export * from "./hdqd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c644729",
  null
  
)

export default component.exports